import {
  Button,
  ButtonProps,
  Glyph,
  Icon,
  ColorPreset,
} from "@gocardless/flux-react";

export const SubmitButton = ({
  isSubmitting,
  dataTestId,
  children,
  ...rest
}: ButtonProps & { isSubmitting: boolean; dataTestId?: string }) => (
  <Button type="submit" data-testid={dataTestId} {...rest}>
    {isSubmitting ? (
      <Icon
        css={{
          display: "flex",
        }}
        color={ColorPreset.IconOnLight_01}
        name={Glyph.Spinner}
        size="22px"
      />
    ) : (
      children
    )}
  </Button>
);
